var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { commands, DATA } from './my-data';
import { newLine, promptTerm, type } from './util';
export var showFolders = function (term) {
    newLine(term);
    Object.keys(DATA).forEach(function (dataKey) {
        term.write(DATA[dataKey].command);
        newLine(term);
    });
    promptTerm(term);
};
export var showNotAvailableAction = function (term, cmd) {
    newLine(term);
    term.write("".concat(cmd, ": command not found"));
    newLine(term);
    term.write('Available commands: ');
    newLine(term);
    commands.forEach(function (cmd) {
        term.write(cmd);
        newLine(term);
    });
    promptTerm(term);
};
export var clearTerminal = function (term) {
    term.clear();
    promptTerm(term);
};
export var showEducations = function (term) { return __awaiter(void 0, void 0, void 0, function () {
    var i, education, firstLine, secondLine, thirdLine;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newLine(term);
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < DATA.education.children.length)) return [3 /*break*/, 6];
                education = DATA.education.children[i];
                firstLine = "".concat(education.title, " - ").concat(education.field);
                return [4 /*yield*/, type(term, firstLine)];
            case 2:
                _a.sent();
                newLine(term);
                secondLine = "".concat(education.university, " - ").concat(education.location);
                return [4 /*yield*/, type(term, secondLine)];
            case 3:
                _a.sent();
                newLine(term);
                thirdLine = "".concat(education.date);
                return [4 /*yield*/, type(term, thirdLine)];
            case 4:
                _a.sent();
                newLine(term);
                _a.label = 5;
            case 5:
                i++;
                return [3 /*break*/, 1];
            case 6:
                promptTerm(term);
                return [2 /*return*/];
        }
    });
}); };
export var showSkills = function (term) { return __awaiter(void 0, void 0, void 0, function () {
    var i, skill;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newLine(term);
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < DATA.skills.children.length)) return [3 /*break*/, 4];
                skill = DATA.skills.children[i];
                return [4 /*yield*/, type(term, "".concat(skill).concat(i === DATA.skills.children.length - 1 ? '' : ', '))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4:
                newLine(term);
                promptTerm(term);
                return [2 /*return*/];
        }
    });
}); };
export var showContact = function (term) { return __awaiter(void 0, void 0, void 0, function () {
    var i, contact, contactLine;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newLine(term);
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < DATA.contact.children.length)) return [3 /*break*/, 4];
                contact = DATA.contact.children[i];
                contactLine = "".concat(contact.title, " => ").concat(contact.value);
                return [4 /*yield*/, type(term, contactLine)];
            case 2:
                _a.sent();
                newLine(term);
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4:
                promptTerm(term);
                return [2 /*return*/];
        }
    });
}); };
